import { render, staticRenderFns } from "./intro_1.vue?vue&type=template&id=1dc9bd12&scoped=true&"
var script = {}
import style0 from "./intro_1.vue?vue&type=style&index=0&id=1dc9bd12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc9bd12",
  null
  
)

export default component.exports